module.exports = __webpack_public_path__ + "static/img/app3.983ecc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/app3.png
// module id = hdbS
// module chunks = 1